<ng-container *ngFor="let value of values">
  <ng-container *ngIf="value.language === currentLanguage">
    {{value.value}}
  </ng-container>
</ng-container>
